import { RELAY_URL } from 'constants/all';

import { isQuotingToolAvailable } from 'modules/common/permissions';

import { RelayPage } from './RelayPage';
import { relayBaseRoute } from './const';

export const buildRelayRoutes = (relayUrl: string | undefined) =>
  relayUrl
    ? [
        {
          path: relayBaseRoute,
          component: RelayPage,
          permissions: [isQuotingToolAvailable],
        },
      ]
    : [];

export const routes = buildRelayRoutes(RELAY_URL);
